import { useTranslation } from 'react-i18next';

/* eslint-disable quotes */
export const useReviews = () => {
  const { i18n } = useTranslation();
  const isEn = i18n.language === 'en';

  const engReviews = [
    {
      username: 'Kim*Kyung',
      review:
        'It was a shame that many 24-hour cafes disappeared these days, but now that Kagong 24 has opened, it’s good to be able to work without worrying about others',
    },
    {
      username: 'Lee*eun',
      review:
        "It's cheaper than studying at a study cafe, and most of all, it's an open space without being stuffy, so I studied comfortably. I hope everything goes well",
    },
    {
      username: 'Lee*Min',
      review: "I think it's good for studying during exam period. Good",
    },
    {
      username: 'Kim*Ri',
      review:
        "A multi-tap is provided to make it easier to use a laptop, and the price is about the price of a coffee, so it's okay if you're going to study all night",
    },
  ];

  const reviews = [
    {
      username: '김*경',
      review: '요즘 24시 카페가 많이 없어져서 아쉬웠는데 카공24 생기고 눈치 안보고 일할 수 있어서 좋아요',
    },
    {
      username: '이*은',
      review:
        '스터디카페에서 공부하는 것보다 저렴하고 무엇보다, 답답하지 않고 열린 공간이라 편하게 공부했어요. 꼭 잘됐으면 좋겠어요',
    },
    {
      username: '이*민',
      review: '시험기간에 공부할 때 좋은 것 같아요. 굳굳',
    },
    {
      username: '김*리',
      review: '노트북 쓰기 편하게 멀티탭도 제공되고 커피값 정도 되는 금액이라 밤새 공부할 거면 괜찮은 듯',
    },
  ];

  return isEn ? engReviews : reviews;
};
